// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___tj_qC","font_button_m":"font_button_m___PGFlr","font_button_s":"font_button_s___XX5qL","categories_container":"categories_container___sQcJd"};